module.exports = __webpack_public_path__ + "static/media/.conf.6f5c4d46.txt";